import { render } from "./PowerUnitSettings.vue?vue&type=template&id=dcc9c0dc&scoped=true"
import script from "./PowerUnitSettings.vue?vue&type=script&lang=js"
export * from "./PowerUnitSettings.vue?vue&type=script&lang=js"

import "./PowerUnitSettings.vue?vue&type=style&index=0&id=dcc9c0dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc9c0dc"]])

export default __exports__